const x = {
  tm: {
    fullScreenControl: true,
    locatorControl: true,
    gazetteerSearchBox: true,
    noInitialLoadingText: true,
    gazetteerSearchBoxPlaceholdertext: "Stadtteil | Adresse | POI",
    photoLightBox: true,
    fallbackBackgroundlayers: "wupp-plan-live@20",
    previewFeatureCollectionCount: -1,
    previewMapPosition: "lat=51.255482567371196&lng=7.14534279930707&zoom=12",
    gazetteerTopicsList: ["pois", "kitas", "quartiere", "bezirke", "adressen"],
    home: {
      center: [51.25910046459786, 7.1810811127858925],
      zoom: 8,
    },
    applicationMenuTooltipString: "Einstellungen | Anleitung",
    applicationMenuIntroductionTerm: "der Parkscheinautomaten",
    applicationMenuIconname: "bars",
    clusteringEnabled: true,
    clusterOptions: {
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: false,
      maxClusterRadius: 40,
      disableClusteringAtZoom: 19,
      animate: false,
      cismapZoomTillSpiderfy: 12,
      selectionSpiderfyMinZoom: 12,
    },
    minZoom: 7,
    maxZoom: 16,
  },
  city: "Wuppertal",
};
export default x;
